import { IconClock } from '../../icon/IconClock';
import { IconFillClose } from '../../icon/IconFillClose';
import { BusinessDescriptionStatus } from '../types';

export const BUSINESS_COVER_RATIO = 16 / 9;

export const descriptionStatusTextMap = {
    [BusinessDescriptionStatus.accepted]: undefined,
    [BusinessDescriptionStatus.limited]: undefined,
    [BusinessDescriptionStatus.declined]: 'Описание отклонено',
    [BusinessDescriptionStatus.moderation]: 'Проверяем описание',
};

export const descriptionStatusIconMap = {
    [BusinessDescriptionStatus.accepted]: undefined,
    [BusinessDescriptionStatus.limited]: undefined,
    [BusinessDescriptionStatus.declined]: IconFillClose,
    [BusinessDescriptionStatus.moderation]: IconClock,
};

export const descriptionStatusColorMap = {
    [BusinessDescriptionStatus.accepted]: undefined,
    [BusinessDescriptionStatus.limited]: undefined,
    [BusinessDescriptionStatus.declined]: 'var(--warning)',
    [BusinessDescriptionStatus.moderation]: 'var(--color-primary)',
};
